var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComparisonTypePlatformLocations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 3H19C17.8954 3 17 3.89543 17 5V9C17 10.1046 17.8954 11 19 11H33C34.1046 11 35 10.1046 35 9V5C35 3.89543 34.1046 3 33 3Z",
    fill: "#FF6833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22H4C2.89543 22 2 22.8954 2 24V34C2 35.1046 2.89543 36 4 36H10C11.1046 36 12 35.1046 12 34V24C12 22.8954 11.1046 22 10 22Z",
    fill: "#8080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22H17C15.8954 22 15 22.8954 15 24V34C15 35.1046 15.8954 36 17 36H23C24.1046 36 25 35.1046 25 34V24C25 22.8954 24.1046 22 23 22Z",
    fill: "#8080FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22H30C28.8954 22 28 22.8954 28 24V34C28 35.1046 28.8954 36 30 36H36C37.1046 36 38 35.1046 38 34V24C38 22.8954 37.1046 22 36 22Z",
    fill: "#8080FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49 22H43C41.8954 22 41 22.8954 41 24V34C41 35.1046 41.8954 36 43 36H49C50.1046 36 51 35.1046 51 34V24C51 22.8954 50.1046 22 49 22Z",
    fill: "#8080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonTypePlatformLocations);
export default __webpack_public_path__ + "static/media/comparison-type-platform-locations.3d0ff6f887d02275d12807a5c96f4ce7.svg";
export { ForwardRef as ReactComponent };